import { FC } from 'react';
import './RecirculationCardSkeleton.scss';

const RecirculationCardSkeleton: FC = () => {
  return (
    <div className="recirculation-card-skeleton">
      <div className="recirculation-card-skeleton__image" />
      <div className="recirculation-card-skeleton__content">
        <div className="recirculation-card-skeleton__category" />
        <div className="recirculation-card-skeleton__title" />
        <div className="recirculation-card-skeleton__publisher" />
      </div>
    </div>
  );
};

export default RecirculationCardSkeleton;
